(function(){
  const CE = window.CozyEmber || {};
  function money(cents){
    const fmt = CE.moneyFormat || "${{amount}}";
    const n = (cents/100);
    const withComma = (v,d,ts,ds)=>{const p=v.toFixed(d).split(".");p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,ts);return p.join(ds);};
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m,k)=>{
      if(k==="amount_no_decimals") return withComma(n,0,",",".");
      if(k==="amount_with_comma_separator") return withComma(n,2,".",",");
      if(k==="amount_no_decimals_with_comma_separator") return withComma(n,0,".",",");
      return withComma(n,2,",",".");
    });
  }

  /* Product hero */
  document.querySelectorAll("[data-product-hero]").forEach(root=>{
    const dataEl = root.querySelector("[data-product-json]");
    if(!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const mainImg = root.querySelector("[data-main-img]");
    const idInput = root.querySelector("[data-variant-id]");
    const qtyInput = root.querySelector("[data-qty-input]");
    const addBtn = root.querySelector("[data-add]");
    const priceEl = root.querySelector("[data-price]");
    const cmpEl = root.querySelector("[data-compare]");
    const saveEl = root.querySelector("[data-save]");
    let variant = product.variants.find(v=>String(v.id)===idInput.value) || product.variants[0];
    const selected = variant.options.slice();

    function showMedia(src, alt, mediaId){
      if(!mainImg) return;
      mainImg.removeAttribute("srcset"); mainImg.src = src; if(alt) mainImg.alt = alt;
      root.querySelectorAll(".thumbs button").forEach(b=>b.setAttribute("aria-pressed", String(b.dataset.mediaId)===String(mediaId)?"true":"false"));
    }
    root.querySelectorAll(".thumbs button").forEach(b=>b.addEventListener("click",()=>showMedia(b.dataset.src,b.dataset.alt,b.dataset.mediaId)));

    function updateBundles(){
      root.querySelectorAll(".bundle").forEach(b=>{
        const q = +b.dataset.qty || 1, d = +b.dataset.discount || 0;
        const full = variant.price*q, sale = Math.round(full*(100-d)/100);
        const p = b.querySelector("[data-bundle-price]");
        if(p) p.innerHTML = money(sale) + (d>0 ? "<s>"+money(full)+"</s>" : "");
      });
    }
    function updateVariant(){
      const v = product.variants.find(v=>v.options.every((o,i)=>o===selected[i]));
      if(!v) return;
      variant = v; idInput.value = v.id;
      priceEl.textContent = money(v.price);
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      cmpEl.hidden = !onSale; saveEl.hidden = !onSale;
      if(onSale){ cmpEl.textContent = money(v.compare_at_price); saveEl.textContent = "Save "+Math.round((1-v.price/v.compare_at_price)*100)+"%"; }
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? "Add to cart" : "Sold out";
      if(v.featured_media && v.featured_media.preview_image){
        const src = v.featured_media.preview_image.src;
        showMedia(src + (src.includes("?")?"&":"?") + "width=1400", v.featured_media.alt || product.title, v.featured_media.id);
      }
      updateBundles();
      if(history.replaceState){ const u=new URL(location.href); u.searchParams.set("variant",v.id); history.replaceState({}, "", u); }
    }
    function pick(index, value){
      selected[index] = value;
      root.querySelectorAll('.swatch[data-option-index="'+index+'"]').forEach(s=>s.setAttribute("aria-pressed", s.dataset.value===value?"true":"false"));
      const lbl = root.querySelector('[data-option-label="'+index+'"]'); if(lbl) lbl.textContent = value;
      updateVariant();
    }
    root.querySelectorAll(".swatch").forEach(s=>s.addEventListener("click",()=>pick(+s.dataset.optionIndex, s.dataset.value)));

    document.querySelectorAll("[data-pick]").forEach(a=>{
      const val = a.dataset.pick; if(!val) return;
      a.addEventListener("click", e=>{
        const idx = product.options.findIndex((_,i)=>product.variants.some(v=>v.options[i]===val));
        if(idx<0) return;
        e.preventDefault(); pick(idx,val); root.scrollIntoView({behavior:"smooth"});
      });
    });

    root.querySelectorAll(".bundle").forEach(b=>b.addEventListener("click",()=>{
      root.querySelectorAll(".bundle").forEach(x=>x.setAttribute("aria-pressed","false"));
      b.setAttribute("aria-pressed","true"); qtyInput.value = b.dataset.qty || 1;
    }));

    const form = root.querySelector("[data-product-form]");
    if(form){
      form.addEventListener("submit", async e=>{
        e.preventDefault();
        addBtn.disabled = true;
        try{
          const r = await fetch((CE.cartAddUrl||"/cart/add")+".js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[{id:+idInput.value,quantity:+qtyInput.value||1}]})});
          if(!r.ok){ const j = await r.json().catch(()=>({})); alertInline(j.description || "Couldn't add to cart. Try again."); }
          else { await refreshCart(); openDrawer(); }
        }catch(err){ form.submit(); }
        finally{ addBtn.disabled = !variant.available; }
      });
    }
    function alertInline(msg){
      let n = root.querySelector(".add-error");
      if(!n){ n=document.createElement("p"); n.className="add-error m"; n.style.color="var(--sale)"; form.after(n); }
      n.textContent = msg;
    }
  });

  /* Cart drawer */
  const drawer = document.querySelector("[data-drawer]");
  function openDrawer(){ if(drawer){ drawer.hidden=false; } }
  function closeDrawer(){ if(drawer){ drawer.hidden=true; } }
  async function refreshCart(){
    const cart = await (await fetch((CE.cartUrl||"/cart")+".js",{headers:{"Accept":"application/json"}})).json();
    document.querySelectorAll("[data-cart-count]").forEach(n=>n.textContent=cart.item_count);
    if(!drawer) return;
    const lines = drawer.querySelector("[data-lines]");
    lines.innerHTML = cart.items.length ? cart.items.map(it=>`
      <div class="line">${it.image?`<img src="${it.image}${it.image.includes("?")?"&":"?"}width=160" alt="">`:"<span></span>"}
        <div><div class="n">${it.product_title}</div>${it.variant_title?`<div class="m">${it.variant_title}</div>`:""}<div class="m">Qty ${it.quantity}</div>
        <button type="button" class="rm" data-key="${it.key}">Remove</button></div>
        <div class="n">${money(it.final_line_price)}</div></div>`).join("") : '<p class="empty">Your cart is empty.</p>';
    drawer.querySelector("[data-subtotal]").textContent = money(cart.total_price);
    lines.querySelectorAll(".rm").forEach(b=>b.addEventListener("click", async()=>{
      await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:b.dataset.key,quantity:0})});
      refreshCart();
    }));
  }
  document.querySelectorAll("[data-cart-open]").forEach(a=>a.addEventListener("click", async e=>{ if(!drawer) return; e.preventDefault(); await refreshCart(); openDrawer(); }));
  document.querySelectorAll("[data-drawer-close]").forEach(b=>b.addEventListener("click", closeDrawer));
  document.addEventListener("keydown", e=>{ if(e.key==="Escape") closeDrawer(); });
})();
